import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import ZasadyWit from '../../elements/ZasadyWit';
import FooterOne from '../../common/footer/FooterOne';

const ZasadyWitryny = () => {
    return (
        <>
        <HeaderOne />
        
        <ZasadyWit />
                
        <FooterOne />
        </>
    )
}
    
export default ZasadyWitryny ;